module.exports = __webpack_public_path__ + "img/x.7853d53e.svg";